import { useState, useEffect } from "react";
import { getDateUtil, today } from "../../util/formatDate";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import XLSX from "xlsx-js-style";
import axios from "axios";

export const useMrp = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [filterCustomer, setFilterCustomer] = useState("GS");
  const [filterBahan, setFilterBahan] = useState("Pilih Bahan");
  const [subMenu, setSubMenu] = useState("Forecast");
  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );
  const [listData, setListData] = useState();

  const [popUpImportStock, setPopUpImportStock] = useState(false);
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [listDataAwal, setListDataAwal] = useState();
  const [isRefresh, setIsRefresh] = useState(false);

  useEffect(() => {
    if (subMenu === "Forecast") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getMrp`,
        {
          tim: dataUser.tim,
          filterCustomer: filterCustomer,
          filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
          filterBahan: filterBahan,
        },
        dataUser.auth,
        setListData,
        ""
      );
    } else if (subMenu === "Stock Awal") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getDataAwal`,
        {
          tim: dataUser.tim,
          company: filterCustomer,
          filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
        },
        dataUser.auth,
        setListDataAwal,
        ""
      );
      setIsRefresh(false);
    }
  }, [subMenu, filterCustomer, filterTahun, filterBulan, isRefresh]);

  const handleExportTemplateBahanBaku = () => {
    const filteredDataExcel = [
      {
        material: "",
        jumlah: "",
      },
    ];

    const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

    workSheet["!cols"] = [{ wch: 45 }, { wch: 14 }];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Bahan Baku");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Template Import Stock Awal.xlsx`);
  };

  const handleImportStockAwal = () => {
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importDataAwal`,
          {
            data: json,
            tim: dataUser.tim,
            filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
            company: filterCustomer,
          },
          {
            headers: {
              Authorization: `Bearer ${dataAuth}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setFile(null);

      setTimeout(() => {
        setPopUpImportStock(false);
        setDisabled(false);
        setIsRefresh(true);
      }, 500);
    } else {
      setDisabled(false);
    }
  };

  return {
    filterCustomer,
    setFilterCustomer,
    subMenu,
    setSubMenu,
    filterBahan,
    setFilterBahan,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    listData,

    popUpImportStock,
    setPopUpImportStock,
    handleExportTemplateBahanBaku,
    handleImportStockAwal,
    setFile,
    disabled,
    setDisabled,
    listDataAwal,
  };
};
